export default __webpack_public_path__ + "static/media/SAmerica.eb8aed71.png";